<template>
  <div class="con_content">
       <div class="container ">
           <div class="container_top h_48">主控台</div>
           
           <div class="head">
               <ul >
                   <!-- 1 -->
                   <li v-if='list.vip'>
                       <div class="li_t">
                           今日新增会员数
                       </div>
                       <div class="li_b"   >
                           <div class="lb_01" >
                               {{ list.vip.todayVipCount | numFun}}
                               
                           </div>
                           <div class="lb_02">
                               <span class="li_span"> 昨日会员 </span> 
                               {{ list.vip.yesterdayVipCount | numFun}}
                           </div>
                           <p class="lineP"></p>
                           <div class="lb_03">
                               <span class="li_span">总会员数</span> 
                               
                               {{ list.vip.vipCount | numFun}}
                           </div>
                       </div>
                      
                   </li>
                   <!-- 2 -->
                   <li>
                       <div class="li_t">
                           今日注册数
                       </div>
                       <div class="li_b" v-if='list.register' >
                           <div class="lb_01" >
                               {{ list.register.todayRegisterCount  | numFun}}
                           </div>
                           <div class="lb_02">
                               <span class="li_span">昨日注册数 </span>
                            
                               {{list.register.yesterdayRegisterCount  | numFun}} 
                           </div>
                           <p class="lineP"></p>
                           <div class="lb_03">
                               <span class="li_span">总注册数</span>
                              
                               {{list.register.allUserCount  | numFun}}
                           </div>
                       </div>
                   </li>
                   <!-- 3 -->
                   <li v-if='list.order' >
                       <div class="li_t">
                           今日订单
                       </div>
                       <div class="li_b"  >
                           <div class="lb_01" >
                               {{list.order.todayOrderCount | numFun}}
                           </div>
                           <div class="lb_02">
                               <span class="li_span">昨日订单 </span>

                               {{ list.order.yesterdayOrderCount  | numFun}}
                               
                           </div>
                           <p class="lineP"></p>
                           <div class="lb_03">
                               <span class="li_span">总订单数</span>
                               
                               {{list.order.allOrderCount  | numFun}} 
                           </div>
                       </div>
                   </li>
                   <!-- 4 -->
                   <li  v-if='list.member' >
                       <div class="li_t">
                           今日新增成员
                       </div>
                      <div class="li_b"  >
                           <div class="lb_01" >
                              
                               {{list.member.todayMemberCount | numFun}}
                           </div>
                           <div class="lb_02">
                               <span class="li_span">昨日新增成员 </span>
                              
                                {{ list.member.yesterdayMemberCount | numFun }}
                           </div>
                           <p class="lineP"></p>
                           <div class="lb_03">
                               <span class="li_span">总成员数</span>
                              
                               {{list.member.allMemberCount  | numFun}} 
                           </div>
                       </div>
                   </li>
                  
               </ul>
               <ul>
                   <!-- 5 -->
                   <li  v-if='list.genealogy' >
                       <div class="li_t">
                           今日新增家谱
                       </div>
                      <div class="li_b"  >
                           <div class="lb_01" >
                              
                               {{list.genealogy.todayGenealogyCount | numFun}}
                           </div>
                           <div class="lb_02">
                               <span class="li_span">昨日新增家谱 </span>
                              
                                {{ list.genealogy.yesterdayGenealogyCount | numFun }}
                           </div>
                           <p class="lineP"></p>
                           <div class="lb_03">
                               <span class="li_span">总家谱数</span>
                              
                               {{list.genealogy.allGenealogyCount  | numFun}} 
                           </div>
                       </div>
                   </li>
               </ul>
           </div>
           <div class="body  ">
               <div class="index_list">
                   <div class="top">
                       <div class="top_r">
                           
                            <div :class="[date==0?'active_date':'']"  @click='dateFun(0)' class="top_r_c pointer">今日</div>
                            <div :class="[date==1?'active_date':'']" @click='dateFun(1)' class="top_r_c">本周</div>
                            <div :class="[date==2?'active_date':'']" @click='dateFun(2)' class="top_r_c">本月</div>
                            <div :class="[date==3?'active_date':'']" @click='dateFun(3)' class="top_r_c">全年</div>
                            <div class="top_r_c"><DatePicker  split-panels type="daterange" @on-change='iv_dateFun'  v-model="iv_date" placement="bottom-start" placeholder="Select date" style="width: 200px"></DatePicker></div>
                           
                       </div>
                       <Tabs :value="titles">
                            <TabPane label="销售额" name="title1" >
                                <div class="tit_L">
                                  
                                    <div id="myChart"  :style="{width: '100%',height: '100%'}"></div>
                                
                                </div>
                                <div class="tit_R">
                                    <div class="titc_LL">
                                        <div id="myChart_c"   :style="{width: '100%',height: '100%'}"></div>
                                    </div>
                                    <div class="titc_RR">

                                    </div>
                                </div>
                            </TabPane>
                            <TabPane label="访问量" name="title2">
                                <div class="tit_L"> 
                                   
                                    <div id="myChart2"  :style="{width: '100%',height: '100%'}"></div>
                           
                                </div>
                                <div class="tit_R">
                                    <div class="titc_T">

                                    </div>
                                    <div class="titc_B">

                                    </div>
                                </div>
                            </TabPane>
                            
                        </Tabs>
                   </div>
                   <div class="bottom">

                   </div>
               </div>
               <div class="bList bottom50"></div>
               
               
           </div>
           
           <listC></listC> 
       </div>
       
  </div>
</template>

<script>
    import listC from './indexC/index_child.vue';
    var echarts = require('echarts');

    export default {
        name:'statistics',
        data () {
            return {
                token:'',
                
                list: Array,


                titles: 'title1',

                sellTime: [],     //销售额
                sellNum:[],     //销售额
                sellAll:[],     //销售饼
                visitTime:[],     //访问量
                visitNum:[],     //访问量
                
            
                myChart:null,
                myChart_c:null,
                myChart2:null,
             
                date: 0,   //时间
                begin: null,
                end: null,
                iv_date: null
            }
        },
       
        watch:{
           
        },
        components: {
            listC:listC
        },

        computed: {
          
            
        },
        methods: {
            load(){
                let that = this;
                
               
                // 顶部
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/statistics/index',
                    data: {},
                    
                }).then(res => {
                       
                        that.list = res.data.data;
                       

                       
                  
                }).catch(err=>{
                    console.log(err)
                });


                

              
           },

           load2(date){
               let that = this;

               if(date != 4){
                    that.begin = null;
                    that.end = null;           
                }
               // 主体echarts
                that.$ajax({
                
                    method:'get',
                    url: 'admin/service/statistics/admin/sale_login?date='+date + '&begin=' + that.begin + '&end=' + that.end,
                    data: {},
                   
                }).then(res => {
                        
                        
                        // 销售额趋势
                        var sell = res.data.data.SalesVolume;
                        that.sellTime = [];
                        that.sellNum = [];
                        for(var i = 0;i < sell.length;i++){
                            that.sellTime.push(sell[i].date);
                            that.sellNum.push(sell[i].count/100)
                           
                        }
                        that.drawLine();
                        
                        // 销售额统计   
                        var sellAll = res.data.data.TodayMoneyType;
                        that.sellAll = [
                            {value: sellAll.monthVip.sum/100,name: sellAll.monthVip.name,itemStyle:{
                                color: '#3aa0ff',
                            }},
                            {value: sellAll.yearVip.sum/100,name: sellAll.yearVip.name,itemStyle:{
                                color: '#36cbcb'
                            }},
                            {value: sellAll.goldCoin.sum/100,name: sellAll.goldCoin.name,itemStyle:{
                                color: '#4dcb73'
                            }},
                            {value: sellAll.sVip.sum/100,name: sellAll.sVip.name,itemStyle:{
                                color: '#fad337'
                            }}
                        ]

                        that.drawLine_c();

                        // 访问量
                        var visit = res.data.data.LoginLog;
                        that.visitTime = [];
                        that.visitNum = [];
                        for(var i = 0;i < sell.length;i++){
                            that.visitTime.push(visit[i].date);
                            that.visitNum.push(visit[i].count)
                           
                        }
                        that.drawLine2();
                       
                  
                }).catch(err=>{
                    console.log(err)
                })
           },
            // 销售额
            drawLine(){
                var that = this;
               
                // 销售额
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('myChart'));
                myChart.resize();
                // 绘制图表
                myChart.setOption({
                    title: { text: '销售额趋势' },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        },
                        right:'3%'
                    },
                    color: ['#2db7f5'],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    grid: {
                        left: '4%',
                        right: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                          
                            data : that.sellTime,
                            axisTick: {
                                alignWithLabel: true
                            }
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value'
                        }
                    ],
                    series : [
                        {
                            name:'销售趋势',
                            type:'bar',
                            barWidth: '60%',
                            data: that.sellNum
                           
                        }
                    ]
                });
               
            },
            // 销售额统计
            drawLine_c(){
                var that = this;
               
                // 销售额统计
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('myChart_c'));
              
                myChart.resize();
                // 绘制图表
                myChart.setOption({
                    title: { text: '销售额统计',left: '4%' },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        },
                        right: '3.5%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        right: '3.5%',
                        top:70,
                        data:['月会员充值','年会员充值','金币充值','SVIP']
                    },
                    series: [
                        {
                            
                            name:'访问来源',
                            type:'pie',
                            radius: ['50%', '76%'],   //圆心
                            center: [ '30%','58%' ],   //圆位置
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '25',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data: that.sellAll
                        }
                    ]
                });
            },
            // 访问量趋势
            drawLine2(){
                var that = this;
                var len = that.sellTime.length;
              
                // 销售额
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('myChart2'))
                myChart.resize();
                // 绘制图表
                myChart.setOption({
                    title: {
                        text: '访问量区域图'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        data:['访问量']
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        },
                        right: '3%'
                    },
                    grid: {
                        left: '4%',
                        right: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data : that.visitTime
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value'
                        }
                    ],
                    series : [
                        {
                            name:'访问量',
                            type:'line',
                            stack: '总量',
                            areaStyle: {
                                normal: {
                                    color: '#8cd5c2' //改变区域颜色
                                }
                            },
                            itemStyle : { 
                                normal : { 
                                    color:'#8cd5c2', //改变折线点的颜色
                                    lineStyle:{ 
                                        color:'#8cd5c2' //改变折线颜色
                                    } 
                                }
                            },
                            data:that.visitNum
                          
                        }
                    ]
                });
            },
             // 时间选择
            dateFun(date){
                let that = this;
                that.date = date;
                that.load2(date);
            },
            // 区间时间选择
            iv_dateFun(data){
                let that = this;
                that.date = 4;
                that.begin = data[0];
                that.end = data[1];
                
                that.load2(4);
            }
           
            
        },
        filters:{
            // 给货币加逗号和小数点，单位是分
            moneyFun(num){
                return  (num/100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');


            },
            numFun(num){
                return  num.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
        },
        mounted: function(){
           var that = this;
            // vuex
           that.token = that.$store.state.token;
           that.load();
           that.load2(0);

           that.drawLine(); 
          
              
          
           window.onresize=function(){
            
                that.drawLine();
                that.drawLine_c();
                that.drawLine2();

            }
        },
       
    }
</script>
<style scoped>
    .active_date{
        color: #2d8cf0;
    }
    .top_r_c:hover{
        color: #5cadff;
    }
    @media screen and (min-width:1501px){
        ul li{
            width: calc( 25% - 15px);
            margin-right: 20px;
        }
        ul li:nth-child(2){
            margin-right: 20px;
        }
    }
    @media screen and (max-width:1500px){
        ul li{
            width: calc( 50% - 10px );
            margin-right: 20px;
        }
        ul li:nth-child(2){
            margin-right: 0;
        }
    }
    .lineP{
        width: 100%;
        height: 1px;
        background: #efefef;
        margin: 10px 0;
    }
    /* 时间选择 */
    .top_r{
        position: absolute;
        right:0;top: 16.5px;
        width:auto;
        height: 37px;
        line-height: 37px;
        z-index: 99999;
    }
    .top_r  .top_r_c{
        display: inline-block;
        font-size: 14px;
        padding: 0 16px;
    }   
    .top_r  .top_r_c:last-child{  /*时间*/
        position: relative;
        top: -2px;
    }


    .head,.foot,.body{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    ul{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    ul li{
        float: left;
        background: white;
        min-height: 10px;
        border: 1px solid #efefef;
        margin-bottom: 10px;
        margin-top: 10px;
        border-radius: 15px;
    }
    ul li:last-child{
        margin-right: 0;
    }

    li .li_t{
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #efefef; 
        
        font-size: 15px;
        font-weight: 500;
    }
    li .li_b{
        height: 150px;
        padding: 20px;
        padding-right: 0;
    }
    /* 左边距 */
    li>div{
        padding-left: 20px;
        text-align: left;
    }
    /* 内容 */
    li .li_b > div{
        width: 100%;
        font-size: 14px;
    }
    li .li_b .lb_01{ 
        padding: 5px 0;
        font-size: 30px;
    }
    

    /* 中间表 */
    .index_list{
        width: 100%;
        height: auto;
        overflow: hidden;
        margin: 10px 0;
       
    }
    .index_list .top{
        width: 100%;
        position: relative;
        padding: 20px  0;
        padding-top: 0;
        background: white;
        margin-bottom: 20px;
    }
    
    .index_list .tit_L{
        width: calc(100% - 520px);
        height: 300px;
        float: left;  
        margin-left: 20px;
      
    }
    
  
    .index_list .tit_R{
        width: 480px; 
        margin-right:  20px; 
        height: 100%;
        float: right;
    }
    .index_list .tit_R .titc_LL{
        width: 480px;
        height: 300px;
    }
    
    .li_span{
        display: inline-block;
        width: 105px !important;
    }
    
    
</style>




